import React from 'react';
import { Megaphone, Shield } from 'lucide-react';

export function WhatIActuallyDo() {
  return (
    <div className="py-10 bg-black/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            What I actually do (without the AI buzzwords)
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Under the hood I use AI, automations, and tools like chatbots and smart phone systems. But you don't need to care about the tech. You just get:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Marketing & Visibility */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-blue-500/20 rounded-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <Megaphone className="w-8 h-8 text-blue-500" />
              <h3 className="text-2xl font-bold text-white">Marketing & Visibility</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Clean, up-to-date Facebook and online profiles</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Consistent posts and simple local campaigns</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Clear offers that match what you actually want to sell</span>
              </li>
            </ul>
          </div>

          {/* Lead Capture & Automation */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-blue-500/20 rounded-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <Shield className="w-8 h-8 text-blue-500" />
              <h3 className="text-2xl font-bold text-white">Lead Capture & Automation</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Text-back systems for missed calls</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Simple automations that log and follow up with leads</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">Basic dashboards so you can see where new clients are coming from</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
